<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Conclusão da Auditoria</h1>
        </header>

        <vs-row>
          <NewSale />
        </vs-row>

        <vs-card
          v-for="(item, index) in conclusion.itens"
          :key="index"
          v-show="item.visible"
        >
          <p v-if="index == 0">
            {{ conclusion.introduction }}
          </p>
          <div slot="header">
            <h3>
              {{ item.name }}
            </h3>
          </div>

          <p v-html="item.message"></p>
          <div>
            <vs-row>
              <vs-divider />
              <vs-col
                v-if="item.field !== 'confirmacao_pre'"
                vs-lg="6"
                vs-sm="12"
              >
                <vs-button
                  icon="arrow_back"
                  style="width: 100%"
                  @click="back(item, index)"
                  v-if="item.field !== 'doc-aluno'"
                >
                  Voltar
                </vs-button>
              </vs-col>
              <vs-col
                v-if="item.field == 'confirmacao_pre'"
                vs-lg="6"
                vs-sm="12"
              >
                <vs-button
                  icon="email"
                  style="width: 100%"
                  color="success"
                  @click="confirmAdvance(item, index)"
                >
                  Confirmar Pré
                </vs-button>
              </vs-col>
              <vs-col vs-lg="6" vs-sm="12">
                <vs-button
                  icon="check_circle"
                  style="width: 100%"
                  color="#139B0E"
                  @click="confirmAdvance(item, index)"
                >
                  Confirmar e Avançar
                </vs-button>
              </vs-col>
            </vs-row>

            <vs-row
              v-show="errors.lenght > 0"
              vs-w="12"
              style="margin-top: 24px"
              vs-justify="center"
            >
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-alert
                  v-for="(error, i) in errors"
                  v-bind:key="i"
                  color="danger"
                  closable
                  close-icon="close"
                  title="Erro na confirmação da pré matrícula"
                >
                  {{ error.error }}
                </vs-alert>
              </vs-col>
            </vs-row>
          </div>
        </vs-card>
        <vs-card style="height: 270px">
          <h2>Divergência</h2>
          <Divergence />
        </vs-card>
        <vs-card style="height: 140px">
          <h2>Cancelamento</h2>
          <!--Componente Cancelamento de Pré-->
          <ReasonsCancel />
        </vs-card>
      </section>
    </div>
  </div>
</template>
<script>
import AuditModel from "../model/Audit.js";
import AuditService from "../services/audits.js";
import PreRegistrationService from "../services/preRegistration.js";
import { getStepsInformation } from "../helpers/storage";
import { notifyError, notifySuccess } from "../helpers/index.js";
import Divergence from "../components/Divergence.vue";
import ReasonsCancel from "../components/ReasonsCancel.vue";

export default {
  name: "AuditStep4",
  components: {
    Divergence,
    ReasonsCancel,
  },
  data: () => ({
    conclusion: null,
    colligateId: null,
    idPerlet: null,
    contractId: null,
    qualificationId: null,
    RA: null,
    preRegistrationId: null,
    errors: [],
    pre: { typeId: null, CODCONTRATO: null },
    type: true,
    contract: null,
  }),
  created() {
    //montagem do objeto de confirmações financeiras
    this.conclusion = new AuditModel().getItem("conclusion");

    //puxar a pré que está salva na sessão e busca os dados da pré no endpoint
    const stepsData = getStepsInformation();
    this.preRegistrationId = stepsData.preRegistrationId;

    this.$vs.loading();
    new PreRegistrationService()
      .getPreRegistration(1, this.preRegistrationId)
      .then((res) => {
        this.pre = res.data;
        console.log(this.pre);
        this.pre.typeId = "O";
        this.$vs.loading.close();
      })
      .catch(() => {
        this.$vs.loading.close();
      });
  },
  methods: {
    async getSendContract() {
      this.$vs.loading();
      const payload = {
        colligateId: this.pre.CODCOLIGADA,
        RA: this.pre.RA,
        idPerlet: this.pre.IDPERLET,
        contractId: this.pre.CODCONTRATO,
        qualificationId: this.pre.IDHABILITACAOFILIAL,
      };
      console.log(payload);
      new AuditService()
        .requestSignature(payload)
        .then(() => {
          this.$vs.loading.close();
          notifySuccess(this, "Contrato enviado com sucesso!");
        })
        .catch(() => {
          this.$vs.loading.close();
          notifyError(this, "Erro ao enviar contrato!");
        });
    },

    async confirmAdvance(item, index) {
      this.type ? (this.pre.typeId = "O") : (this.pre.typeId = "P");
      if (index == 2) {
        await this.confirm(this.pre);
      }
      await this.updatePre(this.preRegistrationId);
      await this.updateContractData(this.pre.CODCONTRATO);
      item.visible = false;
      item.valid = true;
      if (index == this.conclusion.itens.length - 1) {
        this.$router.push("/audits");
      } else {
        this.conclusion.itens[index + 1].visible = true;
      }
    },
    back(item, index) {
      item.visible = false;
      item.valid = true;
      this.conclusion.itens[index - 1].visible = true;
    },

    async updateContractData(contractId) {
      this.$vs.loading();
      new AuditService()
        .getContractData(1, contractId)
        .then((res) => {
          this.contract = res.data;
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    async updatePre(preRegistrationId) {
      this.$vs.loading();
      new PreRegistrationService()
        .getPreRegistration(1, preRegistrationId)
        .then((res) => {
          this.pre = res.data;
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    async confirm(data) {
      //this.$vs.loading();
      this.errors = [];
      const payload = {
        coligateId: data.CODCOLIGADA,
        localId: data.CODLOCAL,
        attendanceId: data.CODATENDIMENTO,
        typeId: data.typeId,
      };
      console.log(payload);
      new PreRegistrationService()
        .confirm(payload, data.IDPREMATRICULA)
        .then((res) => {
          console.log(res.data);
          notifySuccess(this, "Pré-matrícula confirmada com sucesso");
        })
        .catch((error) => {
          this.errors.push({ error: error.response.data.error });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
};
</script>
  <style>
.card {
  padding: 1% 25% 2% 1%;
  margin-inline: 8px;
  transition: all 0.3s ease-out;
  display: block;
}
.introduction {
  padding: 1% 0% 1% 1%;
  font-family: "Segoe UI", Tahoma, Verdana, sans-serif;
  font-weight: 360px;
  font-size: 18px;
  color: #3f3f3f;
  text-align: justify;
}
.message {
  padding: 1% 0% 1% 1%;
  font-family: "Segoe UI", Tahoma, Verdana, sans-serif;
  font-weight: 350px;
  font-size: 16px;
  text-align: justify;
}

.btSteps {
  width: 200px;
  height: 40px;
  margin: 1% 2% 0% 0%;
  text-align: center;
}
.name {
  margin: 1% 2% 0% 1%;
  font-size: 20px;
}
label {
  padding: 0% 1% 0% 0%;
  font-family: "Segoe UI", Tahoma, Verdana, sans-serif;
  font-weight: 350px;
  font-size: 17px;
  text-align: justify;
}
</style>
